/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { candidateReputationDetailSchema } from './candidate-reputation-detail-schema';
import { candidateSchema } from './candidate-schema';
import { opportunitySchema } from './opportunity-schema';
import { TopTaskType } from "../enums";
export const topTaskSchema: z.AnyZodObject = z.object({
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  opportunity: z.lazy(() => opportunitySchema).nullish(),
  opportunityId: z.string().uuid().nullish(),
  ownerId: z.string().uuid().nullish(),
  positionId: z.string().uuid().nullish(),
  reputationDetails: z.lazy(() => candidateReputationDetailSchema).nullish(),
  snoozedAt: z.string().datetime().nullish(),
  taskExpectedCompletionDateTime: z.string().datetime().nullish(),
  taskExpectedStartDateTime: z.string().datetime().nullish(),
  topTaskType: z.nativeEnum(TopTaskType).nullish(),
});

export type TopTask = z.infer<typeof topTaskSchema>;
